'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./PinIt.less');

var PinIt = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  className: 'PinIt',

  propTypes: {
    onTouchTap: React.PropTypes.func
  },

  render: function () {
    return (
      <div className={this.getClassName()}
           onTouchTap={this.props.onTouchTap}>
        <div className='PinIt-button' />
      </div>
    );
  }
});

module.exports = PinIt;


/** WEBPACK FOOTER **
 ** ./atoms/PinIt.jsx
 **/